export const getTaskStatusLabel = (statusIndex, taskType) => {
  if (statusIndex == null || taskType == null) {
    return "";
  }

  const taskStatusMapping = {
    mc: [
      "Created",
      "Preparing",
      "Scheduled",
      "Mirth Connect in progress",
      "Mirth Connect completed",
      "Cleanup in progress",
      "Completed",
    ],
    mcc: [
      "Created",
      "Executing - step 1",
      "Unknown",
      "Unknown",
      "Unknown",
      "Executing - step 2",
      "Completed",
    ],
  };
  const mcTaskTypes = ["resendmessages"];
  const mccTaskTypes = ["deletemessages", "exportmessages", "deletechannels"];
  if (mccTaskTypes.includes(taskType)) {
    return taskStatusMapping.mcc[statusIndex];
  } else if (mcTaskTypes.includes(taskType)) {
    return taskStatusMapping.mc[statusIndex];
  }
  return "Unknown";
};
